import { create } from "zustand";
import { fetchEmployeesListService } from "../services/employeeListStoreServices";

export const useEmployeeStore = create((set) => ({
  employeeList: [],
  loading: false,
  fetchEmployees: async () => {
    await fetchEmployeesListService(set);
  },
}));
